import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fmtMXN, monthShort } from "./format";

const axisStyle = { fontSize: 10, fill: "#71717A", fontFamily: "Geist Mono, monospace" };
const compact = (v) => (v >= 1000000 ? `${(v / 1000000).toFixed(1)}M` : v >= 1000 ? `${Math.round(v / 1000)}k` : v);

function DarkTooltip({ active, payload, label, labelFmt }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#17171A] border border-white/10 rounded-xl px-3 py-2 shadow-2xl">
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 font-mono">{labelFmt ? labelFmt(label) : label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-6 mt-1 text-xs">
          <span className="text-neutral-400">{p.name}</span>
          <span className="font-mono text-white tabular-nums">{fmtMXN.format(p.value)}</span>
        </div>
      ))}
    </div>
  );
}

export function SalesAreaChart({ series, today }) {
  const data = series.filter((d) => !today || d.date <= today);
  return (
    <div className="h-64 md:h-72" data-testid="inv-sales-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 6, left: -14, bottom: 0 }}>
          <defs>
            <linearGradient id="gold" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFBF57" stopOpacity={0.45} />
              <stop offset="100%" stopColor="#FFBF57" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} stroke="rgba(255,255,255,0.05)" />
          <XAxis dataKey="date" tick={axisStyle} tickLine={false} axisLine={false} tickFormatter={(d) => d.slice(8)} interval="preserveStartEnd" minTickGap={18} />
          <YAxis tick={axisStyle} tickLine={false} axisLine={false} tickFormatter={compact} />
          <Tooltip content={<DarkTooltip labelFmt={(d) => new Date(`${d}T12:00:00`).toLocaleDateString("es-MX", { weekday: "short", day: "numeric", month: "short" })} />} cursor={{ stroke: "rgba(255,191,87,0.35)" }} />
          <Area type="monotone" dataKey="ventas" name="Ventas" stroke="#FFBF57" strokeWidth={2} fill="url(#gold)" dot={false} activeDot={{ r: 4, fill: "#FFBF57", stroke: "#0A0A0A", strokeWidth: 2 }} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export function HistoryBars({ history }) {
  return (
    <div className="h-52" data-testid="inv-history-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={history} margin={{ top: 10, right: 6, left: -14, bottom: 0 }} barGap={4}>
          <CartesianGrid vertical={false} stroke="rgba(255,255,255,0.05)" />
          <XAxis dataKey="month" tick={axisStyle} tickLine={false} axisLine={false} tickFormatter={monthShort} />
          <YAxis tick={axisStyle} tickLine={false} axisLine={false} tickFormatter={compact} />
          <Tooltip content={<DarkTooltip labelFmt={monthShort} />} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
          <Bar dataKey="utilidad_neta" name="Utilidad neta" fill="#3F3F46" radius={[4, 4, 0, 0]} />
          <Bar dataKey="cut" name="Tu corte" fill="#FFBF57" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
